import request from "@/utils/request";
import qs from "qs";

/**
 * 查询订单
 * @param params
 * @returns {*}
 */
export function getOrderList(params) {
  return request({
    url: "/shoporder/getList",
    method: "get",
    params
  });
}
/**
 * 订单列表【导出】
 * @param params
 * @returns {*}
 */
export function exportOrderList(params) {
  return request({
    url: "/shoporder/exportList",
    method: "get",
    responseType: "blob", // 重要：设置responseType为'blob'以处理二进制数据
    params
  });
}

/**
 * 查询订单商品列表
 * @param params
 * @returns {*}
 */
export function getGoodsList(params) {
  return request({
    url: "/shoporder/getGoodsList",
    method: "get",
    params
  });
}

/**
 * 发货回执
 * @param params
 * @returns {*}
 */
export function deliveryFeedback(params) {
  return request.post("/shoporder/deliveryFeedback", qs.stringify(params));
}

/**
 * 查询售后订单列表
 * @param params
 * @returns {*}
 */
export function getOrderAfterList(params) {
  return request({
    url: "/orderafter/getList",
    method: "get",
    params
  });
}
/**
 * 查询售后订单详情
 * @param params
 * @returns {*}
 */
export function getOrderAfterDetail(params) {
  return request({
    url: "/orderafter/getDetail",
    method: "get",
    params
  });
}

/**
 * 确认收货
 * @param params
 * @returns {*}
 */
export function confirmOrderAfterReceipt(params) {
  return request.post("/orderafter/confirmReceipt", qs.stringify(params));
}
/**
 * 售后订单反馈
 * @param params
 * @returns {*}
 */
export function feedbackOrderAfter(params) {
  return request.post("/orderafter/feedback", qs.stringify(params));
}
/**
 * 发货回执
 * @param params
 * @returns {*}
 */
export function deliveryOrderAfterFeedback(params) {
  return request.post("/orderafter/deliveryFeedback", qs.stringify(params));
}
